<template>
  <div>
    <h5 class="text-primary mt-4">NUEVO DOMICILIO</h5>
    <b-row class="mb-3">
      <b-col>
        <b-form-group label="Cambio de domicilio de:">
          <b-form-radio-group
            id="btn-radios-2"
            v-model="dst"
            :options="dsts"
            buttons
            button-variant="outline-primary"
            size="md"
            name="radio-btn-outline"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-tabs v-if="dst == 'ur'">
      <b-tab title="Inclusión" active>
        <b-row>
          <b-col sm="12">
            <div v-for="(dom, index) in domicilios" :key="index">
              <domicilio-form
                :domicilio="dom"
                :provincias="provincias"
                v-show="index + 1 == domiciliosPage"
                :touched="touched"
              />
            </div>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col>
            <b-btn size="sm" variant="primary" @click="addDomicilio">
              <i class="fa fa-plus-square-o"></i> Agregar
              Ubicación de Riesgo
            </b-btn>&nbsp;
            <b-btn
              size="sm"
              variant="danger"
              v-if="domicilios.length > 1"
              @click="delDomicilio(domiciliosPage - 1)"
            >
              <i class="fa fa-trash-o"></i> Quitar
            </b-btn>
          </b-col>
          <b-col>
            <b-pagination-nav
              :link-gen="paginate"
              class="domicilios-nav"
              v-if="domicilios.length > 1"
              size="sm"
              v-model="domiciliosPage"
              :number-of-pages="domicilios.length"
            ></b-pagination-nav>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Exclusión">
        <b-textarea
          rows="5"
          v-model="exclusion"
          placeholder="Detalle las ubicaciones a excluir de la póliza"
        />
      </b-tab>
    </b-tabs>

    <b-card border-variant="light" v-else>
      <domicilio-form :domicilio="domicilios[0]" :provincias="provincias" bordered :touched="touched" />
    </b-card>
    <div class="submit-footer">
      <b-row>
        <b-col></b-col>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >
            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>
            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import DomicilioForm from './../DomicilioForm';
import { required, integer } from 'vuelidate/lib/validators';

export default {
  name: 'EndosoCambioDomicilio',
  components: {
    DomicilioForm
  },
  props: ['provincias', 'nroPoliza'],
  data() {
    return {
      sending: false,
      touched: false,
      dst: 'tomador',
      dsts: [
        {
          text: 'Tomador',
          value: 'tomador'
        },
        {
          text: 'Ubicación de Riesgo',
          value: 'ur'
        }
      ],
      municipios: [],
      domicilios: [
        {
          provincia: '',
          localidad: '',
          calle: '',
          numero: '',
          piso: '',
          cp: ''
        }
      ],
      domiciliosPage: 1,
      exclusion: ''
    };
  },
  validations: {
    domicilios: {
      required,
      $each: {
        provincia: { required },
        localidad: { required },
        calle: { required },
        numero: { required, integer },
        cp: { required }
      }
    }
  },
  methods: {
    addDomicilio() {
      this.domicilios.push({
        provincia: '',
        localidad: '',
        calle: '',
        numero: '',
        piso: '',
        cp: ''
      });

      this.domiciliosPage++;
    },

    delDomicilio(index) {
      this.domicilios.splice(index, 1);
      this.domiciliosPage = index > 1 ? index : 1;
    },

    paginate() {
      return null;
    },

    submit: async function() {
      this.$v.domicilios.$touch()

      if (this.$v.domicilios.$invalid) {
        this.touched = true;
        this.$toast.error('Uno o varios formularios contiene campos inválidos');
        return null;
      }

      this.sending = true;

      await this.$api
        .post('endoso/solicitud/cambio-domicilio/' + this.$route.params.cod_tomador, {
          poliza: this.nroPoliza,
          dst: this.dst,
          domicilios: this.domicilios,
          exclusion: this.exclusion,
          pas: {
            nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
            codigo: this.$store.state.auth.cod_agente,
            email: this.$store.state.auth.email
          }
        })
        .then(() => {
          this.domicilios.forEach(dom => {
            for (let index in dom) {
              dom[index] = ''
            }
          });
          this.domiciliosPage = 1;
          this.exclusion = '';
          this.$toast.success('La solicitud de endoso fue enviada exitosamente.');
        })
        .catch(() => {
          this.$toast.error('Ocurrió un error al enviar la solicitud de endoso');
        });

      this.sending = false;
    }
  }
};
</script>
